export default "__VITE_ASSET__Dy1evaqg__"